module.exports = __webpack_public_path__ + "static/media/truck.d6246cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/truck.png
// module id = 3311
// module chunks = 0